import React, { useState } from 'react';

import PartialText from './partials/twb_text';
import PricingCard from './pricing/pricing_card';
import Text from './text';
import StorageMap from './storage_map';
import StreamPriceComparison from './stream_price_comparison';
import { LargeCard } from './large-card';
import TextWithImage from './text/TextWithImage';
import Columns from './columns';
import PricingBandwidth from './pricing/pricing_bandwidth';
import Cta from './cta';

const TabsContent = ({ block, vars }) => {
  const [active, setActive] = useState(0);

  const toggleTabs = e => {
    let index;
    if (e.target.id) {
      index = parseInt(e.target.id, 0);
    } else {
      index = parseInt(e.target.parentElement.id, 0);
    }
    if (index !== active) {
      setActive(index);
    }
  };

  return (
    <section className={`block ${block._template} ${block.css_class_name}`}>
      <div className='container'>
        <ul className='tabs-header'>
          {block.items.map((tab, index) => {
            return (
              <li
                key={index}
                className={`tab-title ${active === index ? 'is-active' : ''}`}
                onClick={toggleTabs}
                active={`${active === index}`}
                id={index}
              >
                {tab.tab_title_mobile ? (
                  <>
                    <span className={`is-desktop`}>{tab.tab_title}</span>
                    <span className={`is-mobile`}>{tab.tab_title_mobile}</span>
                  </>
                ) : (
                  <span>{tab.tab_title}</span>
                )}
              </li>
            );
          })}
        </ul>

        <div className='tabs-wr'>
          {block.items.map((tab, index) => {
            return (
              <div
                key={index}
                className={`tab-content ${active === index ? 'is-active' : ''}`}
                active={`${active === index}`}
              >
                {tab.blocks.map((twb, index) => {
                  switch (twb._template) {
                    case 'partial__text':
                      return (
                        <PartialText
                          key={index}
                          block={twb}
                        />
                      );
                    case 'block__pricing_card':
                      return (
                        <PricingCard
                          key={index}
                          block={twb}
                        />
                      );
                    case 'block__text':
                      return (
                        <Text
                          key={index}
                          block={twb}
                        />
                      );
                    case 'block__stream_price_comparison':
                      return (
                        <StreamPriceComparison
                          key={index}
                          block={twb}
                          vars={vars}
                        />
                      );
                    case 'block__storage_map':
                      return (
                        <StorageMap
                          key={index}
                          block={twb}
                        />
                      );
                    case 'block__large_card':
                      return (
                        <LargeCard
                          key={index}
                          block={twb}
                        />
                      );
                    case 'block__text_with_image':
                      return (
                        <TextWithImage
                          key={index}
                          block={twb}
                        />
                      );
                    case 'block__columns':
                      return (
                        <Columns
                          key={index}
                          block={twb}
                        />
                      );
                    case 'block__pricing_unlimited_bandwidth':
                      return (
                        <PricingBandwidth
                          key={index}
                          block={twb}
                        />
                      );
                    case 'block__cta':
                      if (twb.cta_position === 'Center') {
                        twb.position_class = ' pos-center';
                      }
                      return (
                        <Cta
                          key={index}
                          block={twb}
                        />
                      );
                    default:
                      return 'Missing block.';
                  }
                })}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TabsContent;
